export const logEntryIds = {
    unhandledError: 'ExtensionUnhandledError',
    exportError: 'ExtensionExportError',
    exportStopped: 'ExtensionExportStopped'
};